import { useState } from 'react';
import { EXPORT_CHANNELS } from './PresentationBannerConstants';

interface Props { onSignUp: () => void; }

export function SharePanel({ onSignUp }: Props) {
  const [activeChannel, setActiveChannel] = useState(EXPORT_CHANNELS[0].name);
  const ch = EXPORT_CHANNELS.find(c => c.name === activeChannel) ?? EXPORT_CHANNELS[0];

  return (
    <div className="grid grid-cols-3 gap-5">
      {/* Channel list */}
      <div className="space-y-1.5">
        <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">Choose Format</p>
        {EXPORT_CHANNELS.map(c => (
          <button key={c.name} onClick={() => setActiveChannel(c.name)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border transition-all cursor-pointer text-left ${activeChannel === c.name ? 'border-current bg-white/10' : 'border-white/10 bg-white/5 hover:bg-white/10'}`}
            style={activeChannel === c.name ? { borderColor: c.color + '60' } : {}}>
            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 border"
              style={{ backgroundColor: activeChannel === c.name ? c.bg : 'rgba(255,255,255,0.07)', borderColor: activeChannel === c.name ? c.border : 'rgba(255,255,255,0.1)' }}>
              <i className={`${c.icon} text-base`} style={{ color: activeChannel === c.name ? c.color : '#94a3b8' }}></i>
            </div>
            <div className="min-w-0">
              <p className={`text-xs font-bold truncate ${activeChannel === c.name ? 'text-white' : 'text-slate-400'}`}>{c.name}</p>
              <p className="text-xs text-slate-600 truncate">{c.desc}</p>
            </div>
            {c.badge && (
              <span className="ml-auto text-xs font-bold px-1.5 py-0.5 rounded-md flex-shrink-0" style={{ backgroundColor: c.color + '25', color: c.color }}>{c.badge}</span>
            )}
          </button>
        ))}
      </div>

      {/* Detail panel */}
      <div className="col-span-2 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center border" style={{ backgroundColor: ch.bg, borderColor: ch.border }}>
            <i className={`${ch.icon} text-2xl`} style={{ color: ch.color }}></i>
          </div>
          <div>
            <h3 className="text-base font-extrabold text-white">{ch.name}</h3>
            <p className="text-xs text-slate-400">{ch.desc}</p>
          </div>
        </div>

        <p className="text-sm text-slate-300 leading-relaxed">{ch.detail}</p>

        <div>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">How it works</p>
          <div className="space-y-2">
            {ch.steps.map((s, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-extrabold" style={{ backgroundColor: ch.color + '25', color: ch.color }}>{i + 1}</div>
                <p className="text-sm text-slate-300">{s}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Preview bar */}
        <div className="flex items-center gap-3 px-4 py-3 bg-white/8 rounded-xl border border-white/10">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: ch.color + '20' }}>
            <i className={`${ch.previewIcon} text-lg`} style={{ color: ch.color }}></i>
          </div>
          <code className="text-xs text-slate-300 font-mono flex-1 truncate">{ch.preview}</code>
          <button onClick={onSignUp} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold text-white cursor-pointer hover:opacity-80 whitespace-nowrap" style={{ backgroundColor: ch.color }}>
            <i className="ri-download-2-line text-xs"></i>Export
          </button>
        </div>
      </div>
    </div>
  );
}
